var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useLazyFetch } from '@hn-front/utils';
import { useCallback } from 'react';
import { getEditStudentProps, getAddStudentProps, getDeleteStudentProps, getRecoverStudentProps, getFetchStudentsProps, getFetchDeletedStudentsProps, } from '../api';
var useStudents = function (groupId) {
    var _a = useLazyFetch({
        isCache: false,
        isStale: true,
    }), makeFetchStudentsRequest = _a[0], _b = _a[1], fetchStudentsError = _b.error, studentsResponse = _b.response, remakeFetchStudentsRequest = _b.revalidate;
    var _c = useLazyFetch({
        isCache: false,
        isStale: true,
    }), makeEditRequest = _c[0], editError = _c[1].error;
    var _d = useLazyFetch({
        isCache: false,
        isStale: true,
    }), makeAddRequest = _d[0], addError = _d[1].error;
    var _e = useLazyFetch({
        isCache: false,
        isStale: true,
    }), makeDeleteRequest = _e[0], deleteError = _e[1].error;
    var _f = useLazyFetch({
        isCache: false,
        isStale: true,
    }), makeFetchDeletedStudentsRequest = _f[0], _g = _f[1], fetchDeletedStudentsError = _g.error, deletedStudentsResponse = _g.response, remakeFetchDeletedStudentsRequest = _g.revalidate;
    var _h = useLazyFetch({
        isCache: false,
        isStale: true,
    }), makeRecoverRequest = _h[0], recoverError = _h[1].error;
    var students = studentsResponse !== null && studentsResponse !== void 0 ? studentsResponse : [];
    var deletedStudents = deletedStudentsResponse !== null && deletedStudentsResponse !== void 0 ? deletedStudentsResponse : [];
    var editStudent = useCallback(function (student) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, params;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getEditStudentProps(groupId, student), url = _a.url, params = _a.params;
                    return [4 /*yield*/, makeEditRequest(url, params)];
                case 1:
                    _b.sent();
                    remakeFetchStudentsRequest();
                    return [2 /*return*/];
            }
        });
    }); }, [groupId, makeEditRequest, remakeFetchStudentsRequest]);
    var addStudent = useCallback(function (student) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, params;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getAddStudentProps(groupId, student), url = _a.url, params = _a.params;
                    return [4 /*yield*/, makeAddRequest(url, params)];
                case 1:
                    _b.sent();
                    remakeFetchStudentsRequest();
                    return [2 /*return*/];
            }
        });
    }); }, [groupId, makeAddRequest, remakeFetchStudentsRequest]);
    var deleteStudent = useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, params;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getDeleteStudentProps(groupId, id), url = _a.url, params = _a.params;
                    return [4 /*yield*/, makeDeleteRequest(url, params)];
                case 1:
                    _b.sent();
                    Promise.all([
                        remakeFetchStudentsRequest(),
                        remakeFetchDeletedStudentsRequest(),
                    ]);
                    return [2 /*return*/];
            }
        });
    }); }, [
        groupId,
        makeDeleteRequest,
        remakeFetchStudentsRequest,
        remakeFetchDeletedStudentsRequest,
    ]);
    var recoverStudent = useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, params;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getRecoverStudentProps(groupId, id), url = _a.url, params = _a.params;
                    return [4 /*yield*/, makeRecoverRequest(url, params)];
                case 1:
                    _b.sent();
                    Promise.all([
                        remakeFetchStudentsRequest(),
                        remakeFetchDeletedStudentsRequest(),
                    ]);
                    return [2 /*return*/];
            }
        });
    }); }, [
        groupId,
        makeRecoverRequest,
        remakeFetchStudentsRequest,
        remakeFetchDeletedStudentsRequest,
    ]);
    var getAllStudents = useCallback(function () {
        var _a = getFetchStudentsProps(groupId), studentsURL = _a.url, studentsParams = _a.params;
        var _b = getFetchDeletedStudentsProps(groupId), deletedStudentsURL = _b.url, deletedStudentsParams = _b.params;
        Promise.all([
            makeFetchStudentsRequest(studentsURL, studentsParams),
            makeFetchDeletedStudentsRequest(deletedStudentsURL, deletedStudentsParams),
        ]);
    }, [groupId, makeFetchStudentsRequest, makeFetchDeletedStudentsRequest]);
    var captureError = useCallback(function () {
        var _a, _b;
        if (!(window === null || window === void 0 ? void 0 : window.Sentry))
            return;
        (_a = [
            fetchStudentsError,
            fetchDeletedStudentsError,
            addError,
            editError,
            deleteError,
            recoverError,
        ]) === null || _a === void 0 ? void 0 : _a.filter(Boolean).forEach((_b = window === null || window === void 0 ? void 0 : window.Sentry) === null || _b === void 0 ? void 0 : _b.captureException);
    }, [
        addError,
        deleteError,
        editError,
        fetchDeletedStudentsError,
        fetchStudentsError,
        recoverError,
    ]);
    return {
        students: students,
        getAllStudents: getAllStudents,
        deletedStudents: deletedStudents,
        editStudent: editStudent,
        addStudent: addStudent,
        deleteStudent: deleteStudent,
        recoverStudent: recoverStudent,
        captureError: captureError,
    };
};
export { useStudents };
